import { useMemo } from "react";

import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";

import { type TopLevelBreakdown } from "../types";

export const useAvailableBreakdownConfigs = (excluded: TopLevelBreakdown[]) => {
  const { value: breakdownConfigs } = useSalesBreakdownConfigs();

  return useMemo(() => {
    const excludedKeys = excluded.map((e) => e.key);
    return breakdownConfigs.filter((e) => !excludedKeys.includes(e.key));
  }, [breakdownConfigs, excluded]);
};
